import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { Button, Modal, addToast } from '@octano/global-ui';

import { TranslationsKeys } from '../../../../../../locales/translations';
import { authorizeRequest } from '../../../../Request/api';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  requestId: number;
  observation: string;
  onSuccess: () => void;
}

export default function AuthorizationModal({
  isOpen,
  onClose,
  requestId,
  observation,
  onSuccess,
}: Props) {
  const { t } = useTranslation(
    TranslationsKeys.HOMOLOGATION_AUTHORIZATION_DETAIL,
  );
  const [loading, setLoading] = useState(false);

  const handleAuthorize = async (resolution: 'approved' | 'rejected') => {
    setLoading(true);
    const result = await authorizeRequest(requestId, {
      resolution,
      observation: observation || undefined,
    });
    setLoading(false);

    if (result.error) {
      addToast({
        icon: 'error',
        color: 'danger',
        text: t('toast.error'),
      });
      return;
    }

    addToast({
      icon: 'success',
      color: 'success',
      text:
        resolution === 'approved'
          ? t('toast.approveSuccess')
          : t('toast.rejectSuccess'),
    });
    onSuccess();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose}>
      <div className="text-center mb-4">
        <h5 className="fw-bold">{t('modal.title')}</h5>
        <p className="text-muted">{t('modal.message')}</p>
      </div>

      <Row className="pb-2 pt-2">
        <Col xs={12} sm={4}>
          <Button
            text={t('modal.cancel')}
            outlined
            fullwidth
            onClick={onClose}
            disabled={loading}
          />
        </Col>
        <Col xs={12} sm={4}>
          <Button
            text={t('modal.reject')}
            color="danger"
            fullwidth
            onClick={() => handleAuthorize('rejected')}
            loading={loading}
          />
        </Col>
        <Col xs={12} sm={4}>
          <Button
            text={t('modal.approve')}
            fullwidth
            onClick={() => handleAuthorize('approved')}
            loading={loading}
          />
        </Col>
      </Row>
    </Modal>
  );
}
